// 防抖函数
export function debounce(func, delay, ...arg) {
  let timer = null;
  return function (...args) {
    // 取消已有的定时器（其实可以理解为，取消了上一次的函数调用）
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, [...args, ...arg]);
    }, delay);
  };
}

//创建唯一id方法
export const guid = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

//提取汉字
function GetChinese(strValue) {
  if (strValue !== null && strValue !== "") {
    strValue = strValue?.toString() || "";
    const reg = /[\u4e00-\u9fa5]/g;
    if (strValue.match(reg)) {
      return strValue.match(reg).join("");
    }
  }
  return "";
}

//加千分位符
function comdify(n) {
  var re = /\d{1,3}(?=(\d{3})+$)/g;
  var n1 = n.replace(/^(\d+)((\.\d+)?)$/, function (s, s1, s2) {
    return s1.replace(re, "$&,") + s2;
  });
  return n1;
}

export function decimalNumberFormats(num) {
  if(num < 0.000001){
    return num?.toFixed(8)
  }else if(num < 0.0001){
    return num?.toFixed(6)
  }else if(num < 0.01){
    return num?.toFixed(4)
  }

}
//
export function umberFormats(num) {
  if (num) {
    let isNegative = false;
    if (num < 0) {
      isNegative = true;
    } else if (num < 0.01) {
      return decimalNumberFormats(num);
    }
    let nums = Number(Math.abs(num)).toFixed(2);
    let newNum = Number(nums).toLocaleString("en-US"); // 数字转成千分位 = 123,456.78 有个弊端最多能保留三位小数
    const numArr = newNum.split("."); // 按小数点吧数字拆分 = [123,456, 78]
    if (!numArr[1]) {
      // 如果数组没有下标1的元素，就加.00，例：123,456 = 123,456.00
      newNum = newNum + ".00";
    } else if (numArr[1].length === 1) {
      // 如果数组下标1的元素只有一位小数，就加个0，例：123,456.7 = 123,456.70
      newNum = newNum + "0";
    } else if (numArr[1].length >= 2) {
      // // 如果数组下标1的元素小数位大于等于2位，就截取前两位，例：123,456.789 = 123,456.78
      newNum = numArr[0] + "." + numArr[1].slice(0, 2);
    }
    if (isNegative) {
      return "-" + newNum;
    }
    return newNum;
  } else {
    return "0.00";
  }
}

export function amountFormats(num, digit) {
  if (num) {
    let nums = Number(num) / 10000;
    let newNum = comdify(nums.toString()); // 数字转成千分位 = 123,456.78
    const numArr = newNum.split("."); // 按小数点吧数字拆分 = [123,456, 78]
    if (!numArr[1]) {
      // 如果数组没有下标1的元素
      newNum = newNum + "万";
    } else {
      newNum = digit ? umberFormats(Number(num)) : Number(num).toLocaleString("en-US");
    }
    return newNum;
  } else {
    return "0";
  }
}
//带单位的金额字符串加千分位符
export const addMillimeter = (str, digit) => {
  let num = parseFloat(str);
  let chinese = GetChinese(str);
  num = umberFormats(num);
  return num + chinese;
};

//带单位的金额字符串加千分位符并转成万.
export const addMillimeterAndInit = (str, digit) => {
  let num = parseFloat(str);
  let chinese = GetChinese(str);
  num = amountFormats(num);
  return num + chinese;
};

//判断2个数组是否相等
export function ArrayIsEqual(arr1, arr2) {
  if (arr1 === arr2) {
    //如果2个数组对应的指针相同，那么肯定相等，同时也对比一下类型
    return true;
  } else {
    if (arr1.length != arr2.length) {
      return false;
    } else {
      //长度相同
      for (let i in arr1) {
        //循环遍历对比每个位置的元素
        if (arr1[i] != arr2[i]) {
          //只要出现一次不相等，那么2个数组就不相等
          return false;
        }
      } //for循环完成，没有出现不相等的情况，那么2个数组相等
      return true;
    }
  }
}

//判断小数位是否超过给定的位数
export function isExceedDigit(num, digit) {
  let flag = false;
  const numArr = num.toString().split("."); // 按小数点吧数字拆分 = [123456, 78]
  if (numArr[1] && numArr[1]?.length > digit) {
    flag = true;
  }
  return flag;
}

//下载流文件
export function saveFile(blob, filename) {
  let binaryData = [];
  binaryData.push(blob);
  const objectUrl = window.URL.createObjectURL(new Blob(binaryData));
  const downloadLink = document.createElement("a");
  downloadLink.download = filename;
  downloadLink.href = objectUrl;
  downloadLink.click();
  URL.revokeObjectURL(objectUrl);
}

//数组 去重 keys为多个条件
export function uniqueArray(array, keys) {
  array = array.reduce((pre, next) => {
    let has = pre.some((item) => {
      let flag = true;
      for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        if (item[key] !== next[key]) {
          flag = false;
        }
      }
      return flag;
    });
    if (!has) {
      pre.push(next);
    }
    return pre;
  }, []);
  return array;
}

//数组 判重 keys为多个条件
export function judgmentDuplicateArray(array, keys) {
  for (let index = 0; index < array.length; index++) {
    const item = array[index];
    const items = array?.filter((_) => {
      let flag = true;
      keys?.forEach((key) => {
        if (item[key] !== _[key]) {
          flag = false;
        }
      });
      return flag;
    });
    if (items?.length > 1) {
      return true;
    }
  }
  return false;
}

export const fixArray = () => {
  /* Array.prototype.at() */
  if (!Array.prototype.at) {
    Array.prototype.at = function (index) {
      if (index >= 0) {
        return this[index];
      } else {
        return this[this.length + index];
      }
    };
  }
};

//添加换行
export const initWrap = (str, max) => {
  let line = 1;
  const addWrap = (str, max) => {
    if (str?.length > max) {
      line += 1;
      str = str?.slice(0, max) + "\n" + addWrap(str?.slice(max), max);
    }
    return str;
  };
  str = addWrap(str, max);
  return {
    str,
    line,
  };
};

//判断是否为图片
export const isImage = (path) => {
  path = path.toString();
  const index = path.lastIndexOf(".");
  const type = path.slice(index + 1) || "";
  return ["png", "jpg", "jpeg", "webp"].includes(type);
};

//判断是不是数字格式的字符串
export const isNumberStr = (value) => {
  //正整数
  const reNumber = /^\d+$/;
  //负整数
  const reNeNumber = /^-\d+$/;
  //正实数
  const reRealNumber1 = /^[1-9]\d*[.]\d+$/; //非零开头
  const reRealNumber2 = /^0[.]\d+$/; //零开头
  //负实数
  const reNeRealNumber1 = /^-[1-9]\d*[.]\d+$/; //非零开头
  const reNeRealNumber2 = /^-0[.]\d+$/; //零开头

  let isNumber = false;

  if (
    reNumber.test(value) ||
    reNeNumber.test(value) ||
    reRealNumber1.test(value) ||
    reRealNumber2.test(value) ||
    reNeRealNumber1.test(value) ||
    reNeRealNumber2.test(value)
  ) {
    isNumber = true;
  } else {
    isNumber = false;
  }
  return isNumber;
};

//下载base64图片
export const downloadBase64Img = (src, name) => {
  var base64 = src.toString(); // imgSrc 就是base64哈
  var byteCharacters = atob(
    base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
  );
  var byteNumbers = new Array(byteCharacters.length);
  for (var i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  var byteArray = new Uint8Array(byteNumbers);
  var blob = new Blob([byteArray], {
    type: undefined,
  });
  var aLink = document.createElement("a");
  aLink.download = name;
  aLink.href = URL.createObjectURL(blob);
  aLink.click();
};

//判断 一个数组是否包含另一个数组的所有元素
export const arrayContainsAnotherArray = (needle, haystack) => {
  if (needle?.length === 0) {
    return false;
  }
  for (var i = 0; i < needle?.length; i++) {
    if (haystack.indexOf(needle[i]) === -1) return false;
  }
  return true;
};

//保留小数点后两位 如果小数点后为0则不保留
export const unifyNumber = (num) => {
  if (num === "") {
    return 0;
  } else {
    let handleNum = parseFloat(num);
    let isToFixed =
      handleNum.toString().includes(".") &&
      handleNum.toString().split(".")[1].length > 2;
    if (isToFixed) {
      if (handleNum.toFixed(2).toString().split(".")[1] == "00") {
        return handleNum.toFixed(0);
      } else {
        return handleNum.toFixed(2);
      }
    } else {
      return handleNum;
    }
  }
};

/**
 * 检验18位身份证号码（15位号码可以只检测生日是否正确即可）
 * @author wolfchen
 * @param cid 18为的身份证号码
 * @return Boolean 是否合法
 **/
export const isCnNewID = (cid) => {
  var arrExp = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; //加权因子
  var arrValid = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2]; //校验码
  if (/^\d{17}\d|x$/i.test(cid)) {
    var sum = 0,
      idx;
    for (var i = 0; i < cid.length - 1; i++) {
      // 对前17位数字与权值乘积求和
      sum += parseInt(cid.substr(i, 1), 10) * arrExp[i];
    }
    // 计算模（固定算法）
    idx = sum % 11;
    // 检验第18为是否与校验码相等
    return arrValid[idx] == cid.substr(17, 1).toUpperCase();
  } else {
    return false;
  }
};

//颜色转换 hex转rgba第一种
export const hex2Rgb = (hexValue, alpha = 1) => {
  const rgx = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  const hex = hexValue.replace(rgx, (m, r, g, b) => r + r + g + g + b + b);
  const rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!rgb) {
    return hexValue;
  }
  const r = parseInt(rgb[1], 16),
    g = parseInt(rgb[2], 16),
    b = parseInt(rgb[3], 16);
  return `rgba(${r},${g},${b},${alpha})`;
};

//js动态修改浏览器ico图标
export const change_icon = (iconUrl) => {
  let $favicon = document.querySelector('link[rel="icon"]');
  if ($favicon !== null) {
      $favicon.href = iconUrl;
  } else {
      $favicon = document.createElement("link");
      $favicon.rel = "icon";
      $favicon.href = iconUrl;
      document.head.appendChild($favicon);
  }
}

//获取文件名
export const getFileName = (fileUrl) => {
  if(!fileUrl) return '';
  const index = fileUrl.lastIndexOf("/");
  return fileUrl.slice(index + 1);
}

//获取文件大小
export function getFileSize(size) {//把字节转换成正常文件大小
  if (!size)  return "";
  var num = 1024.00; //byte
  if (size < num)
      return size + "KB";
  if (size < Math.pow(num, 2))
      return (size / num).toFixed(2) + "MB"; //kb
  if (size < Math.pow(num, 3))
      return (size / Math.pow(num, 2)).toFixed(2) + "G"; //M
  if (size < Math.pow(num, 4))
      return (size / Math.pow(num, 3)).toFixed(2) + "T"; //T
}

/**
 * 增强版：判断时间段内是否包含指定的周几或某日（更高效，含健壮性校验）
 * @param {string[]} dateArr ['YYYY-MM-DD', 'YYYY-MM-DD'] 起止日期（包含边界）
 * @param {'W'|'M'} selectType 'W' 按周几, 'M' 按月日
 * @param {number|string} selectValue 周几:1-7(1=周一,7=周日)  日期:1-31
 * @returns {boolean}
 */
export const isIncludeTimeEnhanced = (dateArr, selectType, selectValue) => {
  if (!Array.isArray(dateArr) || dateArr.length !== 2) return false;
  const [startStr, endStr] = dateArr;
  const start = new Date(startStr);
  const end = new Date(endStr);
  if (isNaN(start) || isNaN(end)) return false;
  if (end < start) return false;

  const val = Number(selectValue);
  if (!Number.isInteger(val)) return false;

  if (selectType === 'W') {
    if (val < 1 || val > 7) return false;
    // 计算 start 到最近目标周几的偏移
    const startWeek = start.getDay() === 0 ? 7 : start.getDay();
    let diff = val - startWeek;
    if (diff < 0) diff += 7; // 下一个该周几
    const firstHit = new Date(start);
    firstHit.setDate(start.getDate() + diff);
    return firstHit <= end; // 只要第一次出现不超过结束日期即包含
  } else if (selectType === 'M') {
    if (val < 1 || val > 31) return false;

    // 同月直接判断区间
    if (start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth()) {
      return val >= start.getDate() && val <= end.getDate();
    }

    // 1. 起始月是否还有该日
    const daysInStartMonth = new Date(start.getFullYear(), start.getMonth() + 1, 0).getDate();
    if (val <= daysInStartMonth && val >= start.getDate()) return true;

    // 2. 结束月是否有该日且该日不大于结束日
    if (val <= end.getDate()) return true;

    // 3. 跨越超过一个完整月份，必然包含该日
    const monthSpan = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
    if (monthSpan > 1) return true;

    return false;
  }
  return false;
}

//身份证号加密显示
export function encryptIdCardAdvanced(idCard, options = {}) {
  if (!idCard || idCard.length < 15) return idCard;
  
  const {
    keepStart = 6,    // 保留前几位
    keepEnd = 4,      // 保留后几位  
    maskChar = '*',   // 掩码字符
    showLength = false // 是否显示总长度
  } = options;
  
  const start = idCard.substring(0, keepStart);
  const end = idCard.substring(idCard.length - keepEnd);
  const maskLength = idCard.length - keepStart - keepEnd;
  const mask = maskChar.repeat(maskLength);
  
  let result = start + mask + end;
  
  if (showLength) {
    result += ` (${idCard.length}位)`;
  }
  
  return result;
}